import { Button, Stack, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { publisherOptions } from '@/module/Nomen/Publisher/model/PublisherModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type PublisherSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function PublisherSelectControl<T extends FieldValues>(props: PublisherSelectControlProps<T>) {
  const { data, isLoading, isError, refetch } = useQuery(publisherOptions.getAll());
  const { t } = useTranslation();
  const [hasAddedNew, setHasAddedNew] = useState(false);

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={(data ?? []).map(j => ({ id: j.id, name: j.title }))}
      description={t('publishers.select.limit')}
      limit={100}
      nothingFoundMessage={
        <Stack>
          <Text ta="center">{t('publishers.select.nothingFound')}</Text>
          {!hasAddedNew && (
            <Button
              size="xs"
              onClick={() => {
                window.open('/publisher/create');
                setHasAddedNew(true);
              }}
            >
              {t('button.add')}
            </Button>
          )}
          {hasAddedNew && <Button onClick={() => refetch()}>{t('button.refresh')}</Button>}
        </Stack>
      }
      {...props}
    />
  );
}
